import { useRedux } from "hooks";
import { Link } from "react-router-dom";
import { setActiveTool } from "../redux/actions"
import classnames from "classnames";
import { Utils } from "helpers/utils";

interface BackHeaderIconProps {
  headerOf: "setting"
}
const BackHeaderIcon = ({ headerOf }: BackHeaderIconProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const isDark = Utils.IsDarkTheme();
  const onBackClick = () => {
    switch (headerOf) {
      case "setting":
        dispatch(setActiveTool(null));
        break;
    }
  }
  return (
    <div className="flex-shrink-0 d-block d-md-none me-2">
      <Link
        to="#"
        onClick={onBackClick}
        className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
      >
        <i className="bx bx-chevron-left align-middle"></i>
      </Link>
    </div>
  );
};

export default BackHeaderIcon;